import { useEffect, useState, useCallback } from 'react'

import { withStyles } from '@material-ui/core/styles'
import dayjs from "dayjs"
import {
    Typography, Button,
    MenuItem, Select, InputLabel, FormControl, Grid, Box,
    Snackbar,
    SnackbarContent,
    Paper,Modal,
    TextField
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { format } from 'date-fns'
import styles from './ServiceCaseStyles'
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close'
import Download from '@mui/icons-material/Download'
import { resolve } from 'url'
import { IconButton } from '@material-ui/core'
import EditIcon from '@mui/icons-material/Edit'
import Grid2 from '@mui/material/Unstable_Grid2'
import DateFields from './DateFields'
import Fields from './Fields'
import { FileUploader } from "react-drag-drop-files";
import exportFromJSON from 'export-from-json'
import { backendHosts,apiUrl } from '../../../../ui-utils/apiConfig'
const ServiceCase = ({ classes }) => {

    const [userData,setUserData]=useState(null)
    const [error, setError] = useState("")
    const [snack, setSnack] = useState(false)
    const [snackMessage, setSnackMessage] = useState("")
    const [editModal, setEditModal] = useState(false)
    const [perData,setPerData]=useState(null)
    const [base64,setBase64]=useState(null)
    const [status,setStatus]=useState('Open')

    const [addModal,setAddModal]=useState(false)

    const [type,setType]=useState('')
    const [initBy, setInitBy] = useState('')
    const [initRefCode,setInitRefCode]=useState("")
    const [initClientId,setInitClientId]=useState("")
    const [initEmail,setInitEmail]=useState("")
    const [description, setDescription] = useState("")

    const [fieldInitBy, setFieldInitBy] = useState('')
    const [fieldInitRefCode, setFieldInitRefCode] = useState("")
    const [fieldInitClientId, setFieldInitClientId] = useState("")
    const [fieldInitEmail, setFieldInitEmail] = useState("")
    const [fieldType,setFieldType]=useState("")
    const [filterStatus, setFilterStatus] = useState("")

    const [fileName,setFileName]=useState("")
    const [fileBase64,setFileBase64]=useState("")
    const [tDate, setTdate] = useState(null)
    const [fDate, setFdate] = useState(null)



    const [errors, setErrors] = useState({});

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const validateForm = () => {

        // console.log("inside", fileBase64)
      
        const newErrors = {};

        if (!type) newErrors.type = "Select One of them";
        if (!initBy) newErrors.initBy = "Select One of them";
        if (!initRefCode) newErrors.initRefCode = "Select One of them";
        if (!initEmail) {
            newErrors.initEmail = "Email Required";
        } else if (!validateEmail(initEmail)) {
            newErrors.initEmail = "Invalid email format";
        }
        if (!initClientId) newErrors.initClientId = "ClientId Required";
        if (!description) newErrors.description = "Description field";
       

       

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInitBy=(e)=>{
       setFieldInitBy(e.target.value)
       setFieldInitClientId("")
       setFieldInitRefCode("")
       setTdate(null)
       setFdate(null)
       setFieldType("")
       setFilterStatus("")
        
    }
    const handleClientId = (e) => {
        setFieldInitClientId(e.target.value)
        setFieldInitBy("")
        setFieldInitEmail("")
        setFieldInitRefCode("")
        setTdate(null)
        setFdate(null)
        setFieldType("")
        setFilterStatus("")

    }
    const handleRefCode = (e) => {
        setFieldInitRefCode(e.target.value)
        setFieldInitClientId("")
        setFieldInitEmail("")
        setFieldInitBy("")
        setTdate(null)
        setFdate(null)
        setFieldType("")
        setFilterStatus("")

    }
    const handleEmail = (e) => {
        setFieldInitEmail(e.target.value)
        setFieldInitClientId("")
        setFieldInitRefCode("")
        setTdate(null)
        setFdate(null)
        setFieldType("")
        setFilterStatus("")

    }

    const handleFdate=(value)=>{
        setFdate(dayjs(value).format('YYYY-MM-DD'))
        setFieldInitBy("")
        setFieldInitClientId("")
        setFieldInitEmail("")
        setFieldInitRefCode("")
        setFieldType("")
        setFilterStatus("")
    }
    const handleTdate = (value) => {
        setTdate(dayjs(value).format('YYYY-MM-DD'))
        setFieldInitBy("")
        setFieldInitClientId("")
        setFieldInitEmail("")
        setFieldInitRefCode("")
        setFieldType("")
        setFilterStatus("")
    }

    const handleStatus = (e) => {
        setTdate(null)
        setFdate(null)
        setFieldInitBy("")
        setFieldInitClientId("")
        setFieldInitEmail("")
        setFieldInitRefCode("")
        setFieldType("")
        setFilterStatus(e.target.value)
    }

    const handleType = (e) => {
        setTdate(null)
        setFdate(null)
        setFieldInitBy("")
        setFieldInitClientId("")
        setFieldInitEmail("")
        setFieldInitRefCode("")
        setFieldType(e.target.value)
        setFilterStatus("")
    }


    const handleFieldChange = (field, value) => {
        if (field === "type") setType(value);
        if (field === "initBy") setInitBy(value);
        if (field === "initRefCode") setInitRefCode(value);
        if (field === "initEmail") setInitEmail(value);
        if (field === "initClientId") setInitClientId(value.toUpperCase());
        if (field === "description") setDescription(value);

    

       

        // Clear error for the field if input is valid
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (field === "initEmail" && validateEmail(value)) delete newErrors[field];
            else if (field === "initClientId" && value) delete newErrors[field];
            else if (value) delete newErrors[field];
            return newErrors;
        });
    };

    const handleSubmit = async() => {
       
        if (validateForm()  ) {
            console.log("Form Submitted Successfully");
            const payload={
                data:{
                    type,
                    initiated_by:initBy,
                    initiated_clientId:initClientId,
                    initiated_refcode:initRefCode,
                    initiated_email:initEmail,
                    description,
                    base64:fileBase64
                }
            }
            console.log("payload",payload)


            try {
                const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.serviceCase}`,payload)
              
                if (response.data?.data?.status === 200) {
                    setSnack(true)
                    setSnackMessage("Added Successfully")
                    setFdate("")
                    setTdate("")
                    setInitBy("")
                    setInitClientId("")
                    setInitEmail("")
                    setInitRefCode("")
                    fetchLearningCentreData()
                    handleCloseAddModal()
                    
                } else {
                    console.log('Error in User List API', response.data)
                  }
            } catch (error) {
                console.log('Error in Perticular user  API', error)
            }
            // Handle successful form submission
        }
    };

    const handleFieldSubmit=async()=>{
        const payload = {
            data: {
                from : fDate || "",
                to:tDate || "",
                initiated_by: fieldInitBy || "",
                initiated_clientId: fieldInitClientId || "",
                initiated_refcode: fieldInitRefCode || "",
                initiated_email: fieldInitEmail || "",
                type:fieldType || "",
                status:filterStatus || "",
            }
        }
        console.log("payload", payload)

        try {
            const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.serviceCaseFilter}`, payload)

            if (response.data?.data?.status === 200) {

                setUserData(response.data.data?.data?.data)
                
                
               

            } else {
                console.log('Error in User List API', response.data)
            }
        } catch (error) {
            console.log('Error in Perticular user  API', error)
        }
    }

    const handleReset=()=>{
        setFieldInitBy("")
        setFieldInitClientId("")
        setFieldInitEmail("")
        setFieldInitRefCode("")
        setFieldType("")
        setFilterStatus("")
        setFdate(null)
        setTdate(null)
        fetchLearningCentreData()
    }

    const handlePicFile = async (file, type) => {// added by dev-kartik on 02-04-25
        if (!file) {
            console.error("No file selected.");
            setError("No file selected.")
          
            return;
        }

        const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!validImageTypes.includes(file.type)) {
            setError("Invalid file type. Please upload an image (JPEG, PNG, JPG).");
            setFileBase64("");
       
            return;
        }

        const maxSize = 5 * 1024 * 1024; // 1 MB
        if (file.size > maxSize) {
            setError("File size exceeds the 5MB limit.");
            setFileBase64("");
           
            return;
        }

        try {
            const fileReader = new FileReader();
            fileReader.onload = async () => {
                try {
                    // FileReader provides a Base64-encoded string for image files
                    const base64Image = fileReader.result.split(",")[1];
                    // console.log(base64Image);
                    const data = `data:image/jpeg;base64,${base64Image}`;
                    setFileBase64(data);
                  
                    setError("");
                } catch (error) {
                    console.error("Error converting image to Base64:", error);
                }
            };

            fileReader.readAsDataURL(file); // Triggers Base64 encoding
        } catch (error) {
            console.error("Error reading file:", error);
            // setInccorectErr("Error reading the file.");
        }
        setFileName(file.name);
    };


     useEffect(() => {
        fetchLearningCentreData()
      }, [])

      const fetchLearningCentreData = async () => {
          try {
              const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.serviceCase}`)
              console.log("users", response.data.data?.data?.data)
            if (response.data.data.status === 200) {

              setUserData(response.data?.data?.data?.data)
            } else {
              console.log('Error in User List API', response.data)
            }
          } catch (error) {
            console.log('Error in User List API', error)
          }
        }

    const handleClose = () => {
        setEditModal(false)
        setStatus('Open')
        setPerData(null)
        setBase64(null)
       
          }
    const fontM = {
        fontFamily: "cardiuma-M !important"
    }

    const fontR = {
        fontFamily: "cardiuma-regular !important"
    }

    const handleEditModal = async(id) => {

        const data=userData.filter(ele => ele.id === id )
        // console.log("data",data) 
        setPerData(data[0])
      
        setEditModal(true)
        try {
            const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getAServiceCase}${id}`)
            console.log("users", response.data.data?.data?.base64)
            if (response.data.data.status === 200) {
                if (response.data.data?.data.base64){
                    setBase64(response.data.data?.data?.base64)
                  
                }else{
                    setBase64(null)
                }
                
            } else {
                console.log('Error in Perticular user API', response.data)
            }
        } catch (error) {
            console.log('Error in Perticular user  API', error)
        }
    }
    console.log("perData", perData)

    const columns = [
        {
            field: 'actions',
            headerName: 'Action',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            renderCell: (params) => (
                <IconButton onClick={() => handleEditModal(params.id)} className={classes.edtIcnClr}>
                    <EditIcon  />
                </IconButton>
            ),
          },
        {
          field: 'updatedAt',
          headerName: 'Date',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
          valueFormatter: (params) => format(new Date(params), 'yyyy-MM-dd HH:mm')
        },
        {
            field: 'initiated_by',
            headerName: 'Initiated By',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        {
            field: 'initiated_clientId',
            headerName: 'Initiated ClientId',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'initiated_email',
          headerName: 'Initiated Email',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        {
            field: 'initiated_refcode',
            headerName: 'Initiated Refcode',
          type: 'number',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        
        {
          field: 'type',
          headerName: 'Type',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        
        {
          field: 'status',
          headerName: 'Status',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        
      ]

    const downloadImage=()=>{
        let filename = perData?.initiated_clientId+ "_" + `ticket.jpg`
        const link = document.createElement('a');
        link.href = base64
        link.download = filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);


    }

    const handleSaveStatusChange=async(id)=>{
        try {
            const response = await axios.patch(`${backendHosts.ADMIN}${apiUrl.updateServiceCase}${id}`,{
                data:{
                    status:status,
                    closed_by:"Admin",
                    closed_description:"This is to inform you that your request has for changing brokerage is recieved and completed"
                }
            })
            console.log("users", response.data.data?.data)
            if (response.data.data.status === 200) {
                

                setSnack(true)
                setSnackMessage("Updated Successfully")
                handleClose()
                fetchLearningCentreData()
            } else {
                console.log('Error in Edit API', response.data)
            }
        } catch (error) {
            console.log('Error in edit List API', error)
        }
    }


    const handleAdd=()=>{  
        setAddModal(true)
    }

    const handleCloseAddModal=()=>{
        console.log("close")
        setAddModal(false)
        setType("")
        setInitBy("")
        setInitRefCode("")
        setInitClientId("")
        setInitEmail("")
        setDescription("")
        setErrors({})
        setFileBase64("")
        setError("")
        setFileName("")
    }

    const handleDownloadCsv = () => {
        const header = ["Date", "Initiated By", "Last Activity", "Initiated ClientId", "Initiated Email", "Initiated RefCode", "Type","Status"]

        const data = userData.map(item => {
            return {
                [header[0]]: `${item.createdAt?.split("T")[0]} - ${item.createdAt?.split("T")[1]?.split(".")[0]}`,
                [header[1]]: `${item.initiated_by || '-'}`,
                [header[2]]: `${item.updatedAt?.split("T")[0]} - ${item.updatedAt?.split("T")[1]?.split(".")[0]}`,
                [header[3]]: item.initiated_clientId ? item.initiated_clientId : '-',
                [header[4]]: `${item.initiated_email  || '-'}`,
                [header[5]]: `${item.initiated_refcode || '-'}`,
                [header[6]]: `${item.type || '-'}`,
                [header[7]]: `${item.status}`
                // [header[9]]: item.backoffice == 1 ? 'Yes' : 'No',
                // [header[10]]: item.refcode && item.refcode !== "undefined" ? item.refcode : '-',
                // [header[11]]: item.dramount ? item.dramount : "-" //dev-karthik on 21-01-2025
            }
        })
            const fileName = 'Service Case Report'
                const exportType = exportFromJSON.types.csv
                exportFromJSON({data, fileName, exportType})
    }
    const style = {
        position: 'absolute !important',
        top: '50% !important',
        left: '50% !important',
        transform: 'translate(-50%, -50%) !important',
        width: '60% !important',
      
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '15px !important',
       
      };
    return (
      
        <div className={classes.scrollTable}>
            <Typography
                className={classes.dashboardText2}
                style={{ color: '#FFFFFF', marginTop: '8%' }}
            >Service Case</Typography>
            <DateFields handleAdd={handleAdd} fieldInitClientId={fieldInitClientId} tDate={tDate} fDate={fDate} fieldType={fieldType} handleFdate={handleFdate} handleClientId={handleClientId} handleTdate={handleTdate} handleType={handleType}/>
            <Fields fieldInitBy={fieldInitBy} fieldInitEmail={fieldInitEmail} filterStatus={filterStatus} fieldInitRefCode={fieldInitRefCode} handleInitBy={handleInitBy} handleEmail={handleEmail} handleRefCode={handleRefCode}  handleStatus={handleStatus} handleFieldSubmit={handleFieldSubmit} handleReset={handleReset}  handleDownloadCsv={handleDownloadCsv}/>
            <Paper className={classes.horizantalTablayout} sx={{ height: '80vh',marginTop:"20px"
             }}>
                     <DataGrid
                                    rows={userData}
                                    columns={columns}
                                    // filterModel={filterModel}
                                    // onFilterModelChange={handleNewFilter}
                                    className={classes.customDataGrid}
                                    sx={{
                                        '--DataGrid-containerBackground': '#131E2E',
                                        '--DataGrid-rowBorderColor': '#000',
                                        'border': 0,
                                        width:'100% !important', //dev-trupti on 23-10-2024
                    
                                    }}
                                    getRowId={(row) => row.id}
                                    initialState={{
                                        pagination: {
                                            paginationModel: { page: 0, pageSize: 15 },
                                        },
                                    }}
                    
                                    pageSizeOptions={[15, 25, 50]}
                                />
                 </Paper>



            <Modal open={addModal} onClose={handleCloseAddModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Box
                        sx={{
                            position: "relative",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'cardiuma-M',
                                fontWeight: 'bold',
                                margin: "0 auto",
                                fontSize: "25px !important",
                            }}
                        >
                            Add Case
                        </Typography>
                        <Button onClick={handleCloseAddModal} sx={{ minWidth: 'unset', padding: '0' }}>
                            <CloseIcon style={{ color: 'red' }} />
                        </Button>
                    </Box>

                    {/* Content Section */}
                    <Box sx={{ padding: "20px" }}>
                        <Grid container spacing={2}>
                            {/* Dropdowns */}
                            <Grid item xs={12} md={4}>
                                <TextField
                                    select
                                    label="Type"
                                    fullWidth
                                    value={type}
                                    onChange={(e) => handleFieldChange("type", e.target.value)}
                                    helperText={errors.type}
                                    error={!!errors.type}
                                >
                                    <MenuItem value="">Select an option</MenuItem>
                                    <MenuItem value="Support">Support</MenuItem>
                                    {/* <MenuItem value="option2">Option 2</MenuItem> */}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    select
                                    label="Initiated By"
                                    fullWidth
                                    value={initBy}
                                    onChange={(e) => handleFieldChange("initBy", e.target.value)}
                                    helperText={errors.initBy}
                                    error={!!errors.initBy}
                                >
                                    <MenuItem value="">Select an option</MenuItem>
                                    <MenuItem value="Franchisee">Franchisee</MenuItem>
                                    {/* <MenuItem value="option2">Option 2</MenuItem> */}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    select
                                    label="Select Refcode"
                                    fullWidth
                                    value={initRefCode}
                                    onChange={(e) => handleFieldChange("initRefCode", e.target.value)}
                                    helperText={errors.initRefCode}
                                    error={!!errors.initRefCode}
                                >
                                    <MenuItem value="">Select an option</MenuItem>
                                    <MenuItem value="KAA">KAA</MenuItem>
                                    {/* <MenuItem value="option2">Option 2</MenuItem> */}
                                </TextField>
                            </Grid>

                            {/* Text Fields */}
                            <Grid item xs={12} md={4}>
                                <TextField
                                    label="Enter Email"
                                    fullWidth
                                    value={initEmail}
                                    onChange={(e) => handleFieldChange("initEmail", (e.target.value).toLocaleLowerCase())}
                                    helperText={errors.initEmail}
                                    error={!!errors.initEmail}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    label="Enter ClientId"
                                    fullWidth
                                    value={initClientId}
                                    onChange={(e) => handleFieldChange("initClientId", e.target.value)}
                                    helperText={errors.initClientId}
                                    error={!!errors.initClientId}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    label="Enter Description"
                                    fullWidth
                                    value={description}
                                    onChange={(e) => handleFieldChange("description", e.target.value)}
                                    helperText={errors.description}
                                    error={!!errors.description}
                                />
                            </Grid>

                           
                        </Grid>

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: "20px",
                                marginBottom: "5px",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: "15px",
                                    marginBottom: "10px", // Add spacing between title and uploader
                                    textAlign: "center",
                                }}
                            >
                                Add Image
                            </Typography>
                            <FileUploader
                                multiple={false}
                                maxSize={"1mb"}
                                hoverTitle="rAI"
                                label="Upload or drop a file right here"
                                handleChange={(file) => {
                                    handlePicFile(file);
                                   
                                }}
                                name="file"
                            >
                                <Box
                                    sx={{
                                        width: "400px",
                                        height: "60px",
                                        border: "2px dashed #aaa",
                                        backgroundColor: "#ffffff !important",
                                        borderRadius: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        textAlign: "center",
                                        overflow: "hidden",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            lineHeight: "normal",
                                            margin: "0",
                                        }}
                                    >
                                        Drag and Drop here /{" "}
                                        <span
                                            style={{
                                                color: "#42a0f7",
                                                fontSize: "14px",
                                                fontFamily: "cardiuma-M",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Browse File
                                        </span>
                                    </Typography>
                                </Box>
                            </FileUploader>
                            {error ? (
                                <Typography
                                    sx={{
                                        marginTop:"10px !important",
                                        color: "red !important",
                                        fontSize: "14px !important",
                                        fontFamily: "cardiuma-M !important",
                                    }}
                                >
                                    {error}
                                </Typography>
                            ) : fileName ? (
                                <Typography
                                    sx={{
                                            marginTop: "10px !important",
                                        color: "#000000 !important",
                                        fontSize: "14px !important",
                                        fontFamily: "cardiuma-M !important",
                                    }}
                                >
                                    {fileName}
                                </Typography>
                            ) : null}
                        </Box>

                                          

                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                padding: "30px 0px 10px 0px",
                            }}
                        >
                            <Button
                                onClick={handleSubmit}
                                sx={{
                                    fontFamily: "cardiuma-regular",
                                    color: "#ffffff",
                                    background: "#F44748",
                                    width: "100px",
                                    height: "35px",
                                    "&:hover": {
                                        background: "#F44748",
                                    },
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Box>
                </Box>
            </Modal>




                  <Modal open={editModal} onClose={handleClose} aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                         >
                  
                          <Box sx={style}>
                            <Box
                              sx={{
                            position: "relative", // Allows for absolute positioning of the close icon
                            width: "100%", // Ensures the box spans the entire width of the screen
                            display: "flex",
                            alignItems: "center",
                              }}
                            >
                              <Typography
                               
                                sx={{
                                  fontFamily: 'cardiuma-M',
                                  fontWeight: 'bold',
                                 margin: "0 auto",
                                    fontSize:"25px !important"

                                }}
                              >
                              Details
                              </Typography>
                  
                              <Button onClick={handleClose} sx={{ minWidth: 'unset', padding: '0' }}>
                                <CloseIcon style={{ color: 'red' }} />
                              </Button>
                            </Box>
                  
                            {/* Content section */}
                    <Grid
                        container
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            // alignItems:"center",
                            paddingTop: "20px",
                            // height: "100vh", // Full viewport height
                        }}
                    >
                        <Grid
                            
                            lg={4}
                            sx={{
                                paddingLeft: "90px !important",
                            }}
                        >
                            <Typography mb={3} sx={fontM}>Initiated By:</Typography>
                            <Typography mb={3} sx={fontM}>Initiated Email:</Typography>
                            <Typography mb={3} sx={fontM}>Initiated ClientId:</Typography>
                            <Typography mb={3} sx={fontM}>Initiated RefCode:</Typography>
                            <Typography mb={3} sx={fontM}>Type:</Typography>
                            {/* <Typography mb={3} sx={fontM}>Download Image:</Typography> */}
                            {base64 ? <Typography mb={3} sx={fontM}>Download Image:</Typography>: null}
                           
                            {
                                perData?.status == 'closed' ?(<>
                                   
                                    <Typography mb={3} sx={fontM}>Closed Date:</Typography>
                                    <Typography mb={3} sx={fontM}>Closed By:</Typography>
                                    <Typography mb={11} sx={fontM}>Closed Description:</Typography>
                                   
                                </>):(<>
                                    <Typography mb={3} sx={fontM}>Change Status:</Typography>
                                    <Typography mb={8} sx={fontM}>Description:</Typography>
                                   
                                </>)
                            }
                        </Grid>
                        <Grid  lg={4}
                         sx={{
                                paddingLeft: "20px !important",
                            }}>
                            <Typography sx={fontR} mb={3}>{perData?.initiated_by}</Typography>
                            <Typography sx={fontR} mb={3}>{perData?.initiated_email}</Typography>
                            <Typography sx={fontR} mb={3}>{perData?.initiated_clientId}</Typography>
                            <Typography sx={fontR} mb={3}>{perData?.initiated_refcode}</Typography>
                            <Typography sx={fontR} mb={3}>{perData?.type}</Typography>

                            {
                                base64 ? <> <Typography mb={2} sx={fontM}>
                                    <Download
                                        sx={{ color: "#00acfe", cursor: "pointer" }}
                                        onClick={downloadImage}
                                    />
                                </Typography></>:null
                            }

                           

                            {
                                perData?.status == 'closed' ? (
                                <>
                                        <Typography sx={fontR} mb={3}>
                                            {dayjs(perData?.closed_at).format('YYYY-MM-DD HH:mm')}
                                                    </Typography>
                                        <Typography sx={fontR} mb={3}>{perData?.closed_by}</Typography>
                                        <Typography sx={fontR} mb={3}>{perData?.closed_description}</Typography>
                                </>) : (<>
                                   
                                    <Typography sx={fontR} mb={3}>
                                        <Grid style={{ marginLeft: "0px", borderRadius: "5px" }}>
                                            <FormControl size="small" style={{ width: "50%" }}>
                                                <InputLabel
                                                    className={classes.inputColor}
                                                    id="demo-select-small-label"
                                                    shrink={true} // Ensure the label shrinks
                                                >
                                                    Status
                                                </InputLabel>
                                                <Select
                                                    className={classes.select}
                                                    labelId="demo-select-small-label"
                                                    id="demo-select-small"
                                                    value={status} // Initial value "Open" set here
                                                    label="Status"
                                                    onChange={(e) => {
                                                        const updatedStage = e.target.value;
                                                        console.log("Selected Stage:", updatedStage);
                                                        setStatus(updatedStage);
                                                    }}
                                                    displayEmpty
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                                top: "50px", // Control where dropdown will appear
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <MenuItem className={classes.intSelText} value="Open">
                                                        Open
                                                    </MenuItem>
                                                    <MenuItem className={classes.intSelText} value="closed">
                                                        Close
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>


                                        </Grid>

                                        {/* {error && <Typography color="error" mt={1}>{error}</Typography>} */}
                                    </Typography>
                                    <Typography sx={fontR} mb={4}>{perData?.description}</Typography>
                                </>)
                            }
                           
                        </Grid>
                    </Grid>
                    {
                        perData?.status == 'closed'? <>
                        
                        </> :<>
                        
                                <Grid
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        paddingRight: "50px",
                                        paddingBottom: "10px",
                                    }}
                                >
                                    <Button
                                        onClick={() => handleSaveStatusChange(perData.id)}
                                        sx={{
                                            fontFamily: "cardiuma-regular",
                                            color: "#ffffff",
                                            background: "#F44748",
                                            width: "80px",
                                            height: "35px",
                                            "&:hover": {
                                                background: "#F44748", // Keep the same color on hover
                                            },
                                            "&.Mui-disabled": {
                                                background: "#D3D3D3", // Custom color for disabled state
                                                color: "#ffffff", // Keep the text color
                                            },
                                        }}
                                        disabled={status !== "closed"}
                                    >
                                        Save
                                    </Button>
                                </Grid></>
                    }
                   

                          </Box>
                        </Modal>



            <Snackbar
                open={snack}
                autoHideDuration={2000}
                onClose={() => setSnack(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <SnackbarContent
                    sx={{
                        backgroundColor: "#ffffff !important",
                        color: "black !important",
                        borderLeft: "7px solid #8db600 !important",
                        borderRadius: "3px !important",
                        fontFamily: "cardiuma-regular !important",
                        fontSize: "12px !important",
                    }}
                     
                    message={snackMessage}
                />
            </Snackbar>

        </div>
    )
}

export default withStyles(styles)(ServiceCase)